import TimeClockDetail from '../core/components/time-clock/TimeClockDetail.vue';
import TimeClockScan from '../core/components/time-clock/TimeClockScan.vue';
import ErrorPage from '../core/pages/ErrorPage.vue';
import TimeClockPage from '../core/pages/TimeClockPage.vue';

import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

export const routes: Array<RouteRecordRaw> = [
   {
      path: '/time-clock/:sync_id?',
      name: 'TimeClock',
      component: TimeClockPage,
      meta: { titleKey: 'timeclock.timeclock' },
      redirect: { name: 'TimeClockScan' },
      beforeEnter: (to, _, next) => {
         const { sync_id } = to.params;
         if (!sync_id) return next('/error');

         next();
      },
      children: [
         {
            path: 'scan',
            name: 'TimeClockScan',
            component: TimeClockScan,
            meta: { titleKey: 'timeclock.timeclock' },
         },
         {
            path: 'detail',
            name: 'TimeClockDetail',
            component: TimeClockDetail,
            meta: { titleKey: 'timeclock.timeclock' },
         },
      ],
   },
   {
      path: '/error',
      name: 'Error',
      component: ErrorPage,
      meta: { titleKey: 'error.error' },
   },
   {
      path: '/:pathMatch(.*)*',
      redirect: '/time-clock',
   },
];

const router = createRouter({
   history: createWebHistory(),
   routes,
});

export default router;
